/**

 * UM role template policy names (JWT `PermissionPolicies` claim values).

 * TROC-175: split legacy write into create (direct) vs edit (approval-routed).

 *

 * Claims may use internal feature keys (`RolesCreate`) or ASP.NET policy names (`UM.Roles.Create`).

 */

export const ROLE_PERMISSION_POLICIES = {
  CREATE: 'RolesCreate',

  EDIT: 'RolesEdit'
} as const;

export const ROLE_PERMISSION_POLICY_ALIASES = {
  CREATE: 'UM.Roles.Create',

  EDIT: 'UM.Roles.Edit'
} as const;

/** Pre-TROC-175 legacy JWT policy — grants both create and edit semantics. */
export const LEGACY_ROLE_PERMISSION_POLICY_WRITE = 'UM.Roles.Write' as const;

export type RolePermissionPolicy = (typeof ROLE_PERMISSION_POLICIES)[keyof typeof ROLE_PERMISSION_POLICIES];

/** Shown when submitting role edit/delete/metadata changes for IT approval (TROC-175). */

export const ROLE_CHANGE_APPROVAL_CONFIRMATION =
  "This change will be sent to IT for approval. You'll be notified when it's applied or rejected.";

export function jwtIncludesRolePolicy(policies: Set<string>, policy: RolePermissionPolicy): boolean {
  const hasLegacyWrite = policies.has(LEGACY_ROLE_PERMISSION_POLICY_WRITE);

  if (policy === ROLE_PERMISSION_POLICIES.CREATE) {
    return policies.has(ROLE_PERMISSION_POLICIES.CREATE) || policies.has(ROLE_PERMISSION_POLICY_ALIASES.CREATE) || hasLegacyWrite;
  }

  return policies.has(ROLE_PERMISSION_POLICIES.EDIT) || policies.has(ROLE_PERMISSION_POLICY_ALIASES.EDIT) || hasLegacyWrite;
}
